import React, { useMemo } from 'react';
import { BoardToolbarExpandSearch } from '../../board/toolbar/BoardToolbarExpandSearch';
import { GoDevicesDisplayMenu } from '../../go-config/components/GoDevicesDisplayMenu';
import {
  DEFEITOS_COL_LABELS,
  DEFEITOS_COL_TOGGLE_KEYS,
  DEFEITOS_SORT_OPTIONS,
  fullDefeitosVisibilityState,
} from './defeitosVerveShared';

export function DefeitosVerveToolbar({
  searchQuery,
  onSearchChange,
  sortBy,
  sortDir,
  onSortChange,
  onSortDirChange,
  isDefeitoColVis,
  onToggleCol,
  onRestoreCols,
  children,
}) {
  const sortItems = useMemo(
    () => DEFEITOS_SORT_OPTIONS.map((o) => ({ value: o.key, label: o.label })),
    []
  );
  const colItems = useMemo(
    () => DEFEITOS_COL_TOGGLE_KEYS.map((k) => ({ value: k, label: DEFEITOS_COL_LABELS[k] })),
    []
  );
  const colsCustomized = useMemo(() => {
    const defaults = fullDefeitosVisibilityState();
    return colItems.some((item) => isDefeitoColVis(item.value) !== defaults[item.value]);
  }, [colItems, isDefeitoColVis]);

  return (
    <div className="condicoes-interv-toolbar defeitos-verve-toolbar">
      <BoardToolbarExpandSearch
        value={searchQuery}
        onChange={onSearchChange}
        placeholder="Pesquisar serviços..."
        ariaLabel="Pesquisar serviços"
      />
      <GoDevicesDisplayMenu
        sortItems={sortItems}
        sortBy={sortBy}
        sortDir={sortDir}
        onSortChange={onSortChange}
        onSortDirChange={onSortDirChange}
        colItems={colItems}
        isColVis={isDefeitoColVis}
        onToggleCol={onToggleCol}
        onRestoreCols={onRestoreCols}
        colsCustomized={colsCustomized}
      />
      {children}
    </div>
  );
}
